import * as React from 'react';
import * as _ from 'lodash';
import WorkoutProgressions from '../../../client_app/components/client_checkin_list';
export default function () {
    return React.createElement('div', { 'className': 'row' }, React.createElement(WorkoutProgressions, { 'quickstart_id': this.props.match.params.id }));
}